import React from "react";
import FontAwesome from "react-fontawesome";
import Toggle from "./../common/toggle";

const RederAccountlist = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleOnClick,
  handleChangeToggle,
  onChange,
}) => {
  // console.log("listlist",list)
  return (
    <>
      {list && list.length > 0 &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div className="row" key={item.no}>
                <div className="container-fluid">
                  <div className="card shadow m-1">
                    <div className="card-body">
                      <div ref={lastBookElementRef} className="row">
                        <div className=" col-xs-12 col-sm-3">
                          <div style={{ fontSize: "15px" }}>
                            <span className="badge badge-pill badge-secondary">
                              {item.no}
                            </span>
                          </div>
                          <div style={{ fontSize: "14px" }}>
                            {" "}
                            {"รหัสพนักงาน:"} {item.empid}
                          </div>
                        </div>
                        <div className=" col-xs-12 col-sm-3">
                          <div style={{ fontSize: "14px" }}>
                            {"ชื่อ:"} {item.name}
                          </div>
                          <div style={{ fontSize: "15px" }}>
                            {"แผนก :"}
                            {item.department}
                          </div>
                        </div>
                        <div className=" col-xs-12 col-sm-4">
                          <div style={{ fontSize: "14px" }}>
                            <div className="col-sm-6 my-1">
                              <Toggle
                                name={item.empid + "power"}
                                checked={item.powergroup}
                                disabled={true}
                                onChange={handleChangeToggle}
                                text="สิทธิกลุ่ม Power"
                              />
                            </div>
                          </div>
                          <div style={{ fontSize: "14px" }}>
                            <div className="col-sm-5 ">
                              <Toggle
                                name={item.empid + "non"}
                                checked={item.nonpower}
                                disabled={true}
                                onChange={handleChangeToggle}
                                text="สิทธิ์ Pulp & Paper "
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xs-12  col-sm-2">
                          <div className="d-flex justify-content-end">
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={() => handleOnClick(item.empid, "edit")}
                            >
                              <FontAwesome name="edit" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="row" key={item.no}>
                <div className="container-fluid">
                  <div className="card shadow m-1">
                    <div className="card-body">
                      <div ref={lastBookElementRef} className="row">
                        <div className=" col-xs-12 col-sm-3">
                          <div style={{ fontSize: "15px" }}>
                            <span className="badge badge-pill badge-secondary">
                              {item.no}
                            </span>
                          </div>
                          <div style={{ fontSize: "14px" }}>
                            {" "}
                            {"รหัสพนักงาน:"} {item.empid}
                          </div>
                        </div>
                        <div className=" col-xs-12 col-sm-3">
                          <div style={{ fontSize: "14px" }}>
                            {"ชื่อ:"} {item.name}
                          </div>
                          <div style={{ fontSize: "15px" }}>
                            {"แผนก :"}
                            {item.department}
                          </div>
                        </div>
                        <div className=" col-xs-12 col-sm-4">
                          <div style={{ fontSize: "14px" }}>
                            <div className="col-sm-6 my-1">
                              <Toggle
                                name={item.empid + "power"}
                                checked={item.powergroup}
                                disabled={true}
                                onChange={handleChangeToggle}
                                text="สิทธิกลุ่ม Power"
                              />
                            </div>
                          </div>
                          <div style={{ fontSize: "14px" }}>
                            <div className="col-sm-5 ">
                              <Toggle
                                name={item.empid + "non"}
                                checked={item.nonpower}
                                disabled={true}
                                onChange={handleChangeToggle}
                                text="สิทธิ์ Pulp & Paper "
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-xs-12  col-sm-2">
                          <div className="d-flex justify-content-end mt-2">
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={() => handleOnClick(item.empid, "edit")}
                            >
                              <FontAwesome name="edit" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default RederAccountlist;
